angular.module('archie.core').controller('MyidoptionsController', MyidoptionsController);
function MyidoptionsController($scope, $rootScope, AuthService) {
    $rootScope.$broadcast('progressIndicator', false);
    $scope.loginOIDC = function () {
        AuthService.login();
    };
}
